var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnergy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46.5,
  height: 46.5,
  x: 0.75,
  y: 0.75,
  stroke: "#183690",
  strokeWidth: 1.5,
  rx: 23.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#183690",
  d: "M33 15.25H12A2.75 2.75 0 0 0 9.25 18v12A2.75 2.75 0 0 0 12 32.75h21A2.75 2.75 0 0 0 35.75 30V18A2.75 2.75 0 0 0 33 15.25M34.25 30A1.25 1.25 0 0 1 33 31.25H12A1.25 1.25 0 0 1 10.75 30V18A1.25 1.25 0 0 1 12 16.75h21A1.25 1.25 0 0 1 34.25 18zm5.5-10v8a.75.75 0 1 1-1.5 0v-8a.75.75 0 1 1 1.5 0m-18 3.5V20a.75.75 0 1 1 1.5 0v3.5a.75.75 0 1 1-1.5 0m2 4a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
})));
export default SvgEnergy;